
  import {
    getProjectTypeTranslation,
    projectStates
  } from "../../../_helpers/projectMetadata";
  import ServiceCore from "../../../models/core/ServiceCore";
  import PeopleIcon from "../../../view-models/PeopleIcon";
  import ContextMenu from "../../view_elements/ContextMenu.vue";
  import PeopleIcons from "../../view_elements/PeopleIcons.vue";
  import ServicesCollapse from "./ProjectCollapseServices.vue";

  export default {
    name: "ProjectRow",
    components: { PeopleIcons, ServicesCollapse, ContextMenu },
    props: {
      id: String,
      project: Object
    },
    data() {
      return {
        showCollapse: false,
        projectEndDate: null,
        activeStateString: projectStates.active.name,
        text: {
          projectMember: this.$tc("member", 1),
          projectReader: this.$t("reader")
        }
      };
    },
    computed: {
      servicesByProject(): ServiceCore[] {
        return this.getServicesByProjectId(this.project.getId);
      },
      projectState(): string {
        return this.getLastProjectStateByProjectId(this.project.getId).getState;
      },
      getPeopleIcons(): PeopleIcon[] {
        const projectPOCs = this.getPOCsByProjectId(this.project.getId);
        return projectPOCs.map(people => {
          return PeopleIcon.newPeopleIconFromDx(people);
        });
      }
    },
    methods: {
      changeDateFormat(date: string): string {
        return date != undefined ? this.$moment(date).format("L") : "-";
      },
      getProjectTypeTranslation(projectType: string): string | null {
        return this.$tc(getProjectTypeTranslation(projectType), 1);
      }
    }
  };
